import UUID from 'uuid';

/**
 * @return {string} UUID v4 time based
 */
export const generateUuid = () => {

    return UUID.v4();
};
